import apiContactsService from '@/services/api/ambassador/contactService';
import apiTypeService from '@/services/api/common/typeService';

export default {
  async getContact({ commit }, { contactId }) {
    const contact = await apiContactsService.getById(contactId);
    commit('setSelectedContact', contact);
    commit('app/setFocusedObject', contact, { root: true });
  },
  async getTypes({ commit }) {
    const types = await apiContactsService.getTypes();
    commit('setTypes', types);
  },
  async getTypeCategories({ commit }) {
    const categories = await apiTypeService.getContactCategories();
    commit('setTypeCategories', categories);
  },
  async getSearchTypes({ commit }) {
    const searchTypes = await apiContactsService.getSearchTypes();
    commit('setSearchTypes', searchTypes);
  },
  setSelected({ commit }, contact) {
    commit('setSelectedContact', contact);
  },
  async editContact({ commit }, { field, value }) {
    commit('editContact', { field, value });
  },
};
